import { useEffect, useRef, useState } from 'react';
import { Flex, Stack, Text } from '@chakra-ui/react';
import { FormHandles } from '@unform/core';
import { format, add } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { v4 as uuid } from 'uuid';

import { useAuth } from '../../../hooks/auth';
import { formatPrice } from '../../../utils/format';
import formatInputMoeda from '../../../utils/formatInputMoeda';
import formatPriceNumber from '../../../utils/formatPriceNumber';
import Input from '../../Inputs/Input';
// import SelectInput from '../../Inputs/Selects/SelectInputAntigo';
import SelectInput from '../../Inputs/Selects/SelectInput';

import { Container, Content, ContentData ,FormView, Buttons } from './styles';

type BaixaData = {
	data: string;
	qtd_parcelas: number;
	vlr_baixa: number;
	vlr_desconto: number;
	vlr_multa: number;
	vlr_juros: number;
	total: number;
	vlr_receber: number;
}
interface ModalAddPagBaixaParams {
	onClose: (close: boolean) => void;
	isVisible: boolean;
	baixa: BaixaData;
	pays: any[];
	contas: any[];
	setPagamentos: (pays: any[]) => void;
	pagamentos: any[];
	setFalta: (vlr: number) => void;
	falta: number;
	setTroco: (vlr: number) => void;
	troco: number;
	setTrocos: (pays: any[]) => void;
	trocos: any[];
	setLancamentoJson: (lancamentosJson: any) => void;
	lancamentoJson: any;
	operacao: string;
}

const ModalAddPagBaixa: React.FC<ModalAddPagBaixaParams> = ({
	onClose = () => { },
	isVisible,
	baixa,
	pays,
	contas,
	setPagamentos,
	pagamentos,
	setFalta,
	falta,
	setTroco,
	troco,
	setTrocos,
	trocos,
	setLancamentoJson,
	lancamentoJson,
	operacao,
}) => {
	const formPagRef = useRef<FormHandles>(null);

	const { user } = useAuth();

	const [visible, setVisible] = useState(isVisible);

	const [formaPag, setFormaPag] = useState<any>({});
	const [filteredPays, setFilteredPays] = useState<any[]>([]);

	useEffect(() => {
		if (troco > 0) {
			// let somaTroco = 0;

			/* if (trocos.length > 0) {
				for (let i = 0; i < trocos.length; i++) {
					somaTroco = Number((somaTroco + formatPriceNumber(trocos[i].valor)).toFixed(2));
				};

				somaTroco = Number((troco - somaTroco));

				setTimeout(() => {
					formPagRef.current?.setFieldValue('valor', formatPrice(Math.abs(somaTroco)));
				}, 200);
			} else { */
				setTimeout(() => {
					formPagRef.current?.setFieldValue('valor', formatPrice(troco));
				}, 200);
			// };
		} else {
			if (pagamentos.length > 0) {
				let soma = 0;

				for (let j = 0; j < pagamentos.length; j++) {
					soma = Number((soma + formatPriceNumber(pagamentos[j].valor)).toFixed(2));
				};

				soma = Number((baixa.vlr_receber - soma).toFixed(2));

				setTimeout(() => {
					if (soma < 0) {
						formPagRef.current?.setFieldValue('valor', formatPrice(0));
					} else {
						formPagRef.current?.setFieldValue('valor', formatPrice(soma));
					}
				}, 200);
			} else {
				setTimeout(() => {
					formPagRef.current?.setFieldValue('valor', formatPrice(baixa.vlr_receber));
				}, 200);
			};
		};
	}, []);

	async function onChangeVerifFormaPag(pag: any) {
		const vlrInput = formatPriceNumber(formPagRef.current?.getFieldValue('valor'));

		if (pag.aceita_troco === 'N') {
			if (vlrInput > falta) {
				formPagRef.current?.setFieldValue('valor', formatPrice(falta));
			}
		}
	};

	async function onChangeVerifValor(vlr: string) {
		const vlrInput = formatPriceNumber(vlr);

		if (troco > 0) {
			// let somaTroco = 0;

			/* if (trocos.length > 0) {
				for (let i = 0; i < trocos.length; i++) {
					somaTroco = Number((somaTroco + formatPriceNumber(trocos[i].valor)).toFixed(2));
				};
				somaTroco = somaTroco + vlrInput;

				if ((somaTroco > troco)) {
					formPagRef.current?.setFieldValue('valor', formatPrice(troco));
				}
			} else { */
				if (vlrInput > troco) {
					formPagRef.current?.setFieldValue('valor', formatPrice(troco));
				};
			 // };
		} else {
			let soma = 0;

			for (let j = 0; j < pagamentos.length; j++) {
				soma = Number((soma + formatPriceNumber(pagamentos[j].valor)).toFixed(2));
			};

			if ((soma + vlrInput) > baixa.vlr_receber && formaPag.aceita_troco === 'N') {
				soma = Number((baixa.vlr_receber - soma).toFixed(2));
				formPagRef.current?.setFieldValue('valor', formatPrice(soma));
			};
		};
	};

	async function handleFilterPays(e: any) {
		if (e) {
			setFormaPag({});
			formPagRef.current?.setFieldValue('type_pay', '');
			const filtered = pays.filter(pay => pay.tip_conta === e.conta_tipo);
			setFilteredPays([...filtered]);
		};
	};

	function handleOnClose() {
		setVisible(false);
		setTimeout(() => {
			onClose(false);
		}, 300);
	};

	async function handleSubmit(form: any) {
		try {
			const inputValor = formatPriceNumber(form.valor);
			const conta = contas.find(conta => conta.value === form.conta);
			const pag = pays.find(pay => pay.id_pay === form.type_pay);

			if (!pag) return;

			const id = uuid();

			if (troco > 0) {
				const newTroco = { id, pay: pag, valor: form.valor };

				const newLancamento = {
					id,
					ativa: true,
					vlr_cred: operacao === 'D' ? inputValor : 0,
					vlr_deb: operacao === 'C' ? inputValor : 0,
					caixa: {
						id: conta.value,
						nome: conta.label,
						user_id: user.id,
						user_nome: user.nome,
						compensado: true
					},
					pay: pag
				};

				const auxLancamentoJson = lancamentoJson;
				auxLancamentoJson.lancamentos.push(newLancamento);

				setLancamentoJson({ ...auxLancamentoJson });

				const somaTroco = Number((troco - inputValor).toFixed(2));

				setTrocos([...trocos, newTroco]);
				setTroco(somaTroco);
				handleOnClose();

			} else {
				let soma = 0;
				for (let j = 0; j < pagamentos.length; j++) {
					soma = Number((soma + formatPriceNumber(pagamentos[j].valor)).toFixed(2));
				};

				soma = Number((soma + inputValor).toFixed(2));
				const verif = Number((baixa.vlr_receber - soma).toFixed(2));

				if (verif < 0) {
					setTroco(verif * -1);
				}

				const newFalta = Number((falta - inputValor).toFixed(2));
				setFalta(newFalta >= 0 ? newFalta : 0);

				const id = uuid();

				const newPagamento = {
					id,
					pay: pag,
					qtd_parcelas: form.qtd_parcelas,
					valor: form.valor
				};

				const newLancamento = {
					id,
					ativa: true,
					vlr_cred: operacao === 'C' ? inputValor : 0,
					vlr_deb: operacao === 'D' ? inputValor : 0,
					vlr_pago_cred: operacao === 'C' ? inputValor : 0,
					vlr_pago_deb: operacao === 'D' ? inputValor : 0,
					caixa: {
						id: conta.value,
						nome: conta.label,
						user_id: user.id,
						user_nome: user.nome,
						compensado: true
					},
					data: baixa.data,
					pay: pag
				};

				const auxLancamentoJson = lancamentoJson;
				auxLancamentoJson.lancamentos.push(newLancamento);


				setLancamentoJson({ ...auxLancamentoJson });

				setPagamentos([...pagamentos, newPagamento]);
				handleOnClose();
			};
		} catch (error) {
			console.log('ERROR submit ==>', error);
		}
	};

	return (
		<Container id="ModalAddPagBaixa">
			<Content className={`${visible ? 'active' : ''}`}>
				<FormView ref={formPagRef} onSubmit={handleSubmit}>
					<ContentData>
						<Text fontSize={20} fontWeight={600} py={2} color={troco > 0 ? "red.400" : "gray.700"}>
							ADICIONAR {troco > 0 ? 'TROCO' : 'PAGAMENTO A BAIXA'}
						</Text>
						
						<Flex
							flexDir="column"
							w="100%"
							borderWidth={2}
							borderColor="gray.200"
							borderRadius={8}
							px={2}
							pb={2}
							mb={4}
						>
							{/* DATA BAIXA / QTD PARCELAS */}
							<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
								{/* DATA BAIXA */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Data baixa:</Text>&nbsp;
									<Text fontWeight={500}>
										{format(add(new Date(baixa.data), { days: 1 }), "dd'/'MM'/'Y", { locale: ptBR })}</Text>
								</Flex>

								{/* QTD PARCELAS */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Qtd Parcelas:</Text> &nbsp;
									<Text fontWeight={500}>{baixa.qtd_parcelas}</Text>
								</Flex>
							</Stack>

							{/* VLR BAIXA / VLR DESCONTO */}
							<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
								{/* VLR BAIXA */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Valor da baixa:</Text> &nbsp;
									<Text fontWeight={500}>{formatPrice(baixa.vlr_baixa)}</Text>
								</Flex>

								{/* VLR DESCONTO */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Valor do desconto:</Text> &nbsp;
									<Text fontWeight={500}>{formatPrice(baixa.vlr_desconto)}</Text>
								</Flex>
							</Stack>

							{/* VLR MULTA / VLR JUROS */}
							<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
								{/* VLR MULTA */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Valor da multa:</Text> &nbsp;
									<Text fontWeight={500}>{formatPrice(baixa.vlr_multa)}</Text>
								</Flex>

								{/* VLR JUROS */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Valor do juros:</Text> &nbsp;
									<Text fontWeight={500}>{formatPrice(baixa.vlr_juros)}</Text>
								</Flex>
							</Stack>

							{/* TOTAL / VLR RECEBER */}
							<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
								{/* TOTAL */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Valor Total:</Text> &nbsp;
									<Text fontWeight={500}>{formatPrice(baixa.total)}</Text>
								</Flex>

								{/* VLR RECEBER */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Valor a receber:</Text> &nbsp;
									<Text fontWeight={500}>{formatPrice(baixa.vlr_receber)}</Text>
								</Flex>
							</Stack>

							{/* FALTA / TROCO */}
							<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
								{/* FALTA */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Falta:</Text> &nbsp;
									<Text fontWeight={500} color={falta > 0 ? "red.800" : "gray.700"}>
										{formatPrice(falta)}
									</Text>
								</Flex>

								{/* TROCO */}
								<Flex w="100%">
									<Text fontWeight={500} color="gray.600">Troco:</Text> &nbsp;
									<Text fontWeight={500} color={troco > 0 ? "red.800" : "gray.700"}>
										{formatPrice(troco)}
									</Text>
								</Flex>
							</Stack>
						</Flex>

						<Flex flexDir="column" w="100%">
							{/* CONTA - TIPO DE PAGAMENTO */}
							<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
								{/* CONTA */}
								<div className="input">
									<p>Conta<span>(obrigatório)</span></p>
									<SelectInput
										name="conta"
										placeholder="Conta/Caixa"
										options={contas}
										onChange={async (e: any) =>  await handleFilterPays(e)}
									/>
								</div>

								{/* FORMA PAGAMENTO */}
								<div className="input">
									<p>Forma de Pagamento <span>(obrigatório)</span></p>
									<SelectInput
										name="type_pay"
										placeholder="Pagamentos"
										options={filteredPays}
										onChange={(e: any) => {
											if (e) {
												setFormaPag(e);
												onChangeVerifFormaPag(e);
											}
										}}
									/>
								</div>
							</Stack>
							
							{/* QTD DE PARCELAS - VALOR DA PARCELA */}
							<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
								{/* QTD DE PARCELAS */}
								{troco <= 0 && (
									<div className="input">
										<p>Qtd de Parcelas {formaPag.max_parcel && <span>(maximo: {formaPag.max_parcel})</span>}</p>
										<Input
											name="qtd_parcelas"
											type="number"
											defaultValue={1}
											placeholder="Qtd Parcelas"
											onChange={(e) => {
												if (Number(e.target.value) > formaPag.max_parcel || Number(e.target.value) <= 0) {
													formPagRef.current?.setFieldValue('qtd_parcelas', formaPag.max_parcel);
												}
											}}
											disabled={!formaPag.id_pay}
											containerStyle={{ padding: '6px 0 6px 10px' }}
										/>
									</div>
								)}

								{/* VALOR DA PARCELA */}
								<div className="input">
									<p>Valor <span>(obrigatório)</span></p>
									<Input
										name="valor"
										placeholder="Valor do pagamento"
										onChange={(e) => {
											formatInputMoeda('valor', formPagRef);
											onChangeVerifValor(e.target.value);
										}}
										disabled={!formaPag.id_pay}
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>
							</Stack>
						</Flex>
					</ContentData>

					<Buttons>
						<button
							type="button"
							className="button-cancel"
							onClick={handleOnClose}
						>
							Cancelar
						</button>

						<button
							type="submit"
							className="button-save"
						>
							Adicionar
						</button>
					</Buttons>
				</FormView>
			</Content>
		</Container>
	)
}

export default ModalAddPagBaixa;

/*
<Modal
			isCentered={true}
			size="xl"
			isOpen={isOpen}
			onClose={() => onRequestClose(false)}
		>
			<ModalOverlay />

			<ModalContent mt={0} mx={2}>
				<ModalCloseButton />

				<FormView ref={formPagRef} onSubmit={handleSubmit}>
					<ModalBody>
						<Text fontSize={20} fontWeight={600} py={2} color={troco > 0 ? "red.400" : "gray.700"}>
							ADICIONAR {troco > 0 ? 'TROCO' : 'PAGAMENTO A BAIXA'}
						</Text>

						<Flex
							flexDir="column"
							w="100%"
							borderWidth={2}
							borderColor="gray.200"
							borderRadius={8}
							px={2}
							pb={2}
							mb={4}
						>
							{/* DATA BAIXA / QTD PARCELAS 
<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
	{/* DATA BAIXA 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Data baixa:</Text>&nbsp;
		<Text fontWeight={500}>
			{format(add(new Date(baixa.data), { days: 1 }), "dd'/'MM'/'Y", { locale: ptBR })}</Text>
	</Flex>

	{/* QTD PARCELAS 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Qtd Parcelas:</Text> &nbsp;
		<Text fontWeight={500}>{baixa.qtd_parcelas}</Text>
	</Flex>
</Stack>

{/* VLR BAIXA / VLR DESCONTO 
<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
	{/* VLR BAIXA 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Valor da baixa:</Text> &nbsp;
		<Text fontWeight={500}>{formatPrice(baixa.vlr_baixa)}</Text>
	</Flex>

	{/* VLR DESCONTO 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Valor do desconto:</Text> &nbsp;
		<Text fontWeight={500}>{formatPrice(baixa.vlr_desconto)}</Text>
	</Flex>
</Stack>

{/* VLR MULTA / VLR JUROS 
<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
	{/* VLR MULTA 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Valor da multa:</Text> &nbsp;
		<Text fontWeight={500}>{formatPrice(baixa.vlr_multa)}</Text>
	</Flex>

	{/* VLR JUROS 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Valor do juros:</Text> &nbsp;
		<Text fontWeight={500}>{formatPrice(baixa.vlr_juros)}</Text>
	</Flex>
</Stack>

{/* TOTAL / VLR RECEBER 
<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
	{/* TOTAL 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Valor Total:</Text> &nbsp;
		<Text fontWeight={500}>{formatPrice(baixa.total)}</Text>
	</Flex>

	{/* VLR RECEBER 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Valor a receber:</Text> &nbsp;
		<Text fontWeight={500}>{formatPrice(baixa.vlr_receber)}</Text>
	</Flex>
</Stack>

{/* FALTA / TROCO
<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
	{/* FALTA 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Falta:</Text> &nbsp;
		<Text fontWeight={500} color={falta > 0 ? "red.800" : "gray.700"}>
			{formatPrice(falta)}
		</Text>
	</Flex>

	{/* TROCO 
	<Flex w="100%">
		<Text fontWeight={500} color="gray.600">Troco:</Text> &nbsp;
		<Text fontWeight={500} color={troco > 0 ? "red.800" : "gray.700"}>
			{formatPrice(troco)}
		</Text>
	</Flex>
</Stack>
						</Flex >

	<Flex flexDir="column" w="100%">
		{/* FORMA PAGAMENTO 
		<div className="input">
			<p>Forma de Pagamento <span>(obrigatório)</span></p>
			<SelectInput
				name="tipo_pag"
				placeholder="Pagamentos"
				options={selectPays}
				onChange={(e: any) => {
					setFormaPag(e);
					onChangeVerifFormaPag(e);
				}}
			/>
		</div>

		{/* QTD DE PARCELAS 
		{troco <= 0 && (
			<div className="input">
				<p>Qtd de Parcelas {formaPag.max_parcel && <span>(maximo: {formaPag.max_parcel})</span>}</p>
				<Input
					name="qtd_parcelas"
					type="number"
					defaultValue={1}
					placeholder="Qtd Parcelas"
					onChange={(e) => {
						if (Number(e.target.value) > formaPag.max_parcel || Number(e.target.value) <= 0) {
							formPagRef.current?.setFieldValue('qtd_parcelas', formaPag.max_parcel);
						}
					}}
					disabled={!formaPag.id_pay}
					containerStyle={{ padding: '6px 0 6px 10px' }}
				/>
			</div>
		)}

		{/* VALOR DA PARCELA 
		<div className="input">
			<p>Valor <span>(obrigatório)</span></p>
			<Input
				name="valor"
				placeholder="Valor do pagamento"
				onChange={(e) => {
					formatInputMoeda('valor', formPagRef);
					onChangeVerifValor(e.target.value);
				}}
				disabled={!formaPag.id_pay}
				containerStyle={{ padding: '6px 0 6px 10px' }}
			/>
		</div>
	</Flex>

					</ModalBody>

	<ModalFooter pt={["0", "2"]}>
		<Buttons>
			<button
				type="button"
				className="button-cancel"
				onClick={() => onRequestClose(false)}
			>
				Cancelar
			</button>

			<button
				type="submit"
				className="button-save"
			>
				Adicionar
			</button>
		</Buttons>
	</ModalFooter>
				</FormView>
			</ModalContent>
		</Modal>
*/